import React from "react";
import { Box } from "@mui/material";
import {
  LOGIN_REACHIQ_LOGO,
  NOT_FOUND_ICON,
} from "../../utils/constants/assets";
import { styles } from "./styles";
import { Anchor, RightsTag } from "../../components";
import {
  PRIVACY_POLICY_LINK,
  REACHIQ_HOME,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";
import { Strings } from "./strings";
import Image from "../../image/Image";
import Button from "../../components/Buttons/Button";
import Typography from "../../components/Typography/Typography";
import { fontWeight } from "../../utils/constants/UI";
import { GREY } from "../../utils/constants/colors";

const WaitingScreen = () => {
  const handleNavigation = () => {
    window.location.href = REACHIQ_HOME;
  };
  const classes = styles();

  return (
    <Box
      className={classes.head}
      //   sx={{
      //     display: "flex",
      //     flexDirection: "column",
      //     justifyContent: "space-between",
      //     height: "100vh",
      //   }}
    >
      <Box className={classes.logo_container}>
        <Image
          onClick={handleNavigation}
          src={LOGIN_REACHIQ_LOGO}
          className={classes.reachiqLogo}
        />
      </Box>
      <Box className={classes.invalidContentContainer}>
        <Image
          onClick={handleNavigation}
          className={classes.IMMAGE}
          src={NOT_FOUND_ICON}
        />
        <Typography
          label={Strings.HI_THERE}
          color={GREY.PRIMARY}
          size={"dxs"}
          fontWeight={fontWeight.SEMIBOLD}
        />
        {/* <h4 className={classes.sorryTitle}>Hi There !</h4> */}
        {/* <p className={classes.sorryPara}>We have received your request.</p> */}

        <Typography
          label={Strings.REQ_RECIEVED}
          color={GREY.TERTIARY}
          size={"sm"}
          fontWeight={fontWeight.REGULAR}
        />
        <Typography
          label={Strings.REACH_OUT}
          color={GREY.TERTIARY}
          size={"sm"}
          fontWeight={fontWeight.REGULAR}
        />
        {/* <p className={classes.sorryPara}>{Strings.REACH_OUT}</p> */}
        {/* <button className={classes.btn} onClick={handleNavigation}>
          Go Home
        </button> */}
        <div>
          <Button
            size={"sm36"}
            variant={"primary"}
            label={Strings.GO_HOME}
            onClick={handleNavigation}
          />
        </div>
      </Box>
      <Box>
        {/* <Box className={ classes.containIcons } >
                <img  src={ LOGIN_REACHIQ_LOGO } alt="reahiq_logo" className={ classes.reachiqLogo } />
                <Box sx={{display:"flex"}} >
                    <InstagramIcon fontSize="medium" className={ classes.icon } />
                    <FacebookIcon fontSize="medium" className={ classes.icon } />
                    <LinkedInIcon fontSize="medium" className={ classes.icon } />
                </Box>
            </Box> */}
        {/* <Box className={classes.containFooter}>
          <Box>
            <p className={classes.sorryPara}>
              © {new Date().getFullYear()} ReachIQ. All rights reserved.
            </p>
          </Box>
          <Box>
            <Anchor
              target="_blank"
              className={classes.link}
              href={TERMS_SERVICE_LINK}
            >
              Terms of service
            </Anchor>
            <Anchor
              target="_blank"
              className={classes.link}
              href={PRIVACY_POLICY_LINK}
            >
              Privacy Policy
            </Anchor>
            <Anchor
              target="_blank"
              className={classes.link}
              style={{ borderRight: "none" }}
              href={DO_NOT_SELL_LINK}
            >
              Do not sell my information
            </Anchor>
          </Box>
        </Box> */}
        <div className={classes.containPolicy}>
          <RightsTag className={classes.termsPara} />
          {/* Privacy and Terms. */}
          <Anchor
            href={PRIVACY_POLICY_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            {Strings.PRIVACY}
          </Anchor>
          <div className={classes.TypoHead}>
            <Typography
              size={"xs"}
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
              label={Strings.AND}
            />{" "}
          </div>
          <Anchor
            href={TERMS_SERVICE_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            {Strings.TERMS}
          </Anchor>
        </div>
      </Box>
    </Box>
  );
};

export default WaitingScreen;
